module.exports = __webpack_public_path__ + "img/geographical-local-lore.093442ef.jpg";